<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card min-height">
          <TableLoading v-if="sampleOrder.publicId === '0'"/>
          <div v-else class="card-body">
            <div class="invoice-title">
              <h4 class="float-end font-size-16">Invoice # {{sampleOrder.invoiceId}}</h4>
              <div class="mb-4">
                <img
                    src="@/assets/images/KikkomanNameLogo.png"
                    alt="logo"
                    height="20"
                />
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <address>
                  <strong>From:</strong>
                  <br />Kikkoman East Africa <br/>P.O BOX 52781-00100 <br/>Tel: 0790 366 564 or Tel: 0740 949 997 (CS)<br/>Tel: 0110 111 999 (Office)
                  <br />Pin P051667186Z
                </address>
              </div>
              <div class="col-6 text-sm-end">
                <address>
                  Sample Order by:<br />
                  <strong>{{sampleOrder.orderedBy}}</strong>
                </address>
                <address v-if="sampleOrder.customer !== null">
                  Customer:<br />
                  <strong>{{sampleOrder.customer.name}}</strong>
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-6 mt-3"></div>
              <div class="col-6 mt-3 text-sm-end">
                <address>
                  <strong>Due Date:</strong>
                  <br /> {{sampleOrder.deliveryDate}}
                  <br /><br />
                </address>
              </div>
            </div>
            <div class="my-5 ml-3">
              <add-sample-product-component :order-id="sampleOrder.publicId" @addItemToOrder="addItemToOrder"/>
            </div>
            <div class="my-5">
              <div class="table-responsive">
                <table class="table">
                  <thead class="table-light">
                    <tr>
                      <th style="width: 70px">No.</th>
                      <th>Product Name</th>
                      <th>Unit Price</th>
                      <th>Order Unit</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, index) in sampleOrder.orderItems" :key="item.publicId">
                    <tr>
                      <td>{{index+1}}</td>
                      <td>{{item.item.productName}}</td>
                      <td>Ksh {{item.grossItemTotal | formatNumber}}</td>
                      <td><b-form-input v-model="item.itemCount" class="px-4 w-50" style="outline: 0;border-width: 0 0 2px;border-radius: 0"></b-form-input></td>
                      <td>
                        <div class="button-items">
                          <b-button variant="dark" size="sm" disabled v-if="ordersLoading">
                            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                            Loading
                          </b-button>
                          <b-button variant="dark" size="sm" class="py-1 text-white" @click="updateOrderItem(item)" v-else>
                            Update
                          </b-button>
                          <b-button variant="danger" size="sm" disabled v-if="ordersLoading">
                            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                            Loading
                          </b-button>
                          <b-button variant="danger" size="sm" class="py-1 text-white" @click="removeItemFromOrder(item.publicId)" v-else>
                            Remove
                          </b-button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row justify-content-between my-5">
                  <div class="col-4"></div>
                  <div class="col-4">
                    <div class="my-2 pb-2">
                      <strong>Total:</strong>
                      <p class="float-end">Ksh {{sampleOrder.grossOrderTotal | formatNumber}}</p>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-start my-5">
                  <div class="col-5">
                    <div class="button-items" v-if="sampleOrder.canCancelOrder">
                      <b-button variant="danger" size="lg" class="py-1 text-white" @click="cancelOrder(sampleOrder.publicId)">
                        Cancel Order
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import {SINGLE_SAMPLE_ORDER} from "@/gql/orders";
import {mapActions, mapGetters} from "vuex";
import {successToast} from "@/components/successToast";
import AddSampleProductComponent from "@/components/orders/customize_order/add-sample-product-component";
import TableLoading from "@/components/TableLoading";

export default {
  page: {
    title: "Customize Sample Order",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, AddSampleProductComponent, PageHeader, Layout},
  name: "customize-sample-order",
  data() {
    return {
      title: "Customize Sample Order",
      items: [
        {
          text: "Orders",
          href: routeItems.customer_orders_route
        },
        {
          text: "Customize Sample Order",
          active: true
        }
      ],
      quantity: 34,
      sampleOrder: {
        publicId: '0',
        invoiceId: "",
        deliveryDate: "",
        orderedBy:"",
        customer: {
          name : ""
        },
        orderItems: [{
          publicId: "",
          item: {
            productName: "",
            qpoUnit:""
          },
          itemCount: "",
          grossItemTotal: "",
          canCancelOrder: false,
        }],
        grossOrderTotal: "",
      }
    }
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading'
    }),
  },
  apollo: {
    sampleOrder: {
      query: SINGLE_SAMPLE_ORDER,
      variables(){
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  methods: {
    ... mapActions({
      addToOrder: 'orders/addItemToSampleOrder',
      updateOrder: 'orders/updateSampleOrderItem',
      removeFromOrder: 'orders/deleteItemFromSampleOrder',
      changeSampleOrderStatus: 'orders/changeSampleOrderStatus',
    }),
    async updateOrderItem(item){
      const data = {
        id: item.publicId,
        sampleOrder: this.sampleOrder.publicId,
        itemId: item.item.publicId,
        itemCount: parseInt(item.itemCount),
        shipmentId: item.shipment.publicId
      }

      await this.updateOrder(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.sampleOrder.refetch()
        }

      })
    },
    async addItemToOrder(data){
      await this.addToOrder(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.sampleOrder.refetch()
        }

      })
    },
    async removeItemFromOrder(id){
      await this.removeFromOrder({'id': id}).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.sampleOrder.refetch()
        }

      })
    },
    async cancelOrder(orderId){
      const data = {sampleOrderId: orderId ,statusId: "c518ae7e-0732-46cb-b234-da118cdfd8f9"}
      await this.changeSampleOrderStatus(data).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.sampleOrder.refetch()
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
